import { ContractStatusEnum, ProjectStatusEnum } from 'gql/graphql';
import { Button, cnMixSpace } from 'uikit';

import { ModalsCreateWorkOrder } from './ModalsCreateWorkOrder';
import { useCreateWorkOrder } from './useCreateWorkOrder';

export const CreateWorkOrder = ({
    projectId,
    contractData,
    statusProject,
    statusContract,
}: {
    projectId?: string;
    contractData?: Record<string, any>;
    statusProject?: ProjectStatusEnum;
    statusContract?: ContractStatusEnum;
}) => {
    const {
        orderRules,
        isContractModalActive,
        isUnreadyModalActive,
        unreadyUerMsg,
        CreateWorkOrderConfirmationDialog,
        modalContractConfirmHandler,
        modalUnreadyConfirmHandler,
        modalCancelHandler,
        uploadClickHandler,
    } = useCreateWorkOrder(projectId, contractData);

    const isContractStatusWork = statusContract === ContractStatusEnum.InImplementation;

    const isProjectStatusDelayed = statusProject === ProjectStatusEnum.Delayed;
    const isProjectStatusCompleted = statusProject === ProjectStatusEnum.Completed;

    const isDisabledByProjectStatus = isProjectStatusDelayed || isProjectStatusCompleted;

    return (
        <>
            <Button
                label="Создать Наряд-Заказ"
                view="primary"
                size="s"
                className={cnMixSpace({ mR: 's' })}
                onClick={uploadClickHandler}
                disabled={!orderRules.canCreate || !isContractStatusWork || isDisabledByProjectStatus}
            />
            <ModalsCreateWorkOrder
                isContractModalActive={isContractModalActive}
                isUnreadyModalActive={isUnreadyModalActive}
                unreadyUerMsg={unreadyUerMsg}
                modalCancelHandler={modalCancelHandler}
                modalContractConfirmHandler={modalContractConfirmHandler}
                modalUnreadyConfirmHandler={modalUnreadyConfirmHandler}
            />
            {CreateWorkOrderConfirmationDialog}
        </>
    );
};

CreateWorkOrder.displayName = 'CreateWorkOrder';
